import { actionCreators } from "react/api/actions/modals";
import { getResourceTo } from "react/utils/utils";

class EventLogRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'EventLog';
        const model = App.Models.EventLog;
        const collectionClass = App.Collections.EventLogs;

        super(entityName, model, collectionClass);
    }

    makeListScreen = (layout) => {
      if (layout) {
        const entity = layout.userInterfaceAction.userInterface.key;
        const tabIdSelector = 'EventLogGrid'

        this.updateTabTitle(layout);

        if (!this.permissionDenied) {
          Monet.Form.checkFormTemplate(tabIdSelector);
          this.generateDatamapper(entity, layout);

          const form = this.renderMonetForm(entity, layout, tabIdSelector);

          if (this.beforeInitializeGrid) {
            this.beforeInitializeGrid(form, layout);
          }

          form.initializeGrid(this.customGridActions)

          this.beforeList();
          this.executeCustomFilter(entity);
        }
      } else {
        new Greenmile.Components.AlertModal("Greenmile.error.layout.notFound")
          .show();
      }
      return this;
    }

    removeGridHeader = function () {
      const element = document.querySelector('#EventLogGrid div.gridHeaderContainer');

      element && element.remove();
    }

    beforeInitializeGrid = function (form, pageLayout) {
      this.removeGridHeader();

      form.initializeGrid = () => {
        const grid = new Monet.Builder.Form.Grid(pageLayout, 'EventLog');

        grid.getGridOptions = function () {
          const entity = 'EventLog';

          return {
            entity: entity,
            columnCheckBox: {
              show: true,
              checkBoxEventClass: [Greenmile.EventLog.ResolveInBatch],
              options: {
                checkOnClickRow: true
              }
            },
            columnEdit: {
              show: false
            },
            actions: ["CUSTOM_FILTERS", "SAVE_LAYOUT", "CUSTOMIZE_COLUMNS", "EXPORT_FORMATS"],
            gridActionsSelector: '#EventLogGrid .gridActions',
            gridContainner: '#EventLogGrid .gridContainer',
            entityToActionGrid: entity,
            headerMenu: {
              headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
            },
            multiColumnSort: true,
            multiSelect: false,
            frozenColumn: Monet.Grid.getIndexFrozenColumn(pageLayout)
          };
        };

        grid.filterBuilderCallbacks = {
          beforeFilter: this.afterList
        };

        grid.show();
      };
    }

    beforeList = function (status) {
      const grid = App.Forms.EventLog.table;

      const onClickGrid = (event, args) => {
        event.preventDefault();

        const model = args.grid.getDataItem(args.row).model;
        const eventLogId = String(model.get('id'));

        window.GreenmileReduxStore.dispatch(
          actionCreators.openModal({
            modalKey: 'eventDetails',
            title: getResourceTo('eventDetails.modal.title', 'Event Details'),
            data: {
              eventLogId
            }
          })
        );
      }

      if (status !== 'update') {
        grid.onClick.unsubscribe(onClickGrid);
        grid.onClick.subscribe(onClickGrid);
      }

    }

    afterList = function () {
      if (Monet.Session.EventLog?.filters) {
        const filterBuilder = App.Forms.EventLog.filterBuilder;
        const {
          id,
          clearFilters,
          event,
        } = Monet.Session.EventLog.filters;

        const defaultFilters = {
          'event': {
            value: event
          },
        };

        if(clearFilters) {
          filterBuilder.clearFilter();
          filterBuilder.setDefaultFilters(defaultFilters);
          filterBuilder.setSelectedFilters(defaultFilters);
          filterBuilder.addDefaultFilters();
          filterBuilder.renderSelectedFields();
        }

        filterBuilder.criteriaChain = filterBuilder.getCriteriaChain();
        filterBuilder.projection    = filterBuilder.getProjection();

        filterBuilder.criteriaChain.criteriaChain[0].and.push({
          attr: 'id',
          eq: id
        });

        delete Monet.Session.EventLog.filters;
      }
    }
}

App.Routers.EventLog = EventLogRouter;
